import { Component, Input } from '@angular/core';
import { Tag } from 'primeng/tag';

import { UserRole } from '@/enums';
import { ValueOrPipe } from '@/pipes';

@Component({
    selector: 'app-role',
    standalone: true,
    template: `
        <p-tag
            [severity]="getRoleSeverity(value)">{{ value | valueOr }}</p-tag>
    `,
    imports: [
        Tag,
        ValueOrPipe
    ]
})
export class AppRoleComponent {
    @Input() value!: UserRole | string | null;

    getRoleSeverity(role: UserRole | string | null): string {
        switch (role) {
            case UserRole.ADMIN:
                return 'info';
            default:
                return 'primary';
        }
    }
}
